import SFS2X, { SFSObject, SFSArray } from "sfs2x-api";
import { get } from 'svelte/store';
import { attachSFSToLogger } from "../utils/LogUtil";
import userStore from "../stores/userStore";
import { accessToken } from '../stores/cachedStores';
import friendsStore from "../stores/friendsStore";
import { showToast } from '../utils/Toast';

export const ZONE_NAME = "Poker";
export const USE_SSL = true;
export const TOKEN = "token";
export const USER_ID = "userId";
export const USER_NAME = "userName";
export const PHOTO = "photo";
export const LOCALE = "locale";
export const BALANCE = "balance";
export const FRIENDS = "friends";
export const BLOCKED = "blocked";
export const SEAT = "seat";
export const CHIPS = "chips";
export const SIT_OUT = "sitOut";
export const PLAYERS = "players";

export const UPDATE_USER_LOCATION_CMD = "pokerClient.updateUserLocation";
export const UNFRIEND_CMD = "pokerClient.unfriend";
export const UNBLOCK_CMD = "pokerClient.unblock";
export const UNFRIEND_MSG = "pokerServer.unfriend";
export const CALL_AT_TABLE_CMD = "pokerClient.callAtTable";
export const CALL_AT_TABLE_MSG = "pokerServer.callAtTable";
export const UPDATE_FRIENDS_MSG = "pokerServer.updateFriends";

var sfs;
var globalSfs;
var casinoId;
var tableId;
var lobbyRoom;
var tableRoom;
var onLoggedIn;
var onJoinedLobby;
var onJoinedTable;

export const globalSFSHost = document.currentScript.getAttribute('globalSFSHost');
export const globalSFSPort = document.currentScript.getAttribute('globalSFSPort');

export function initGlobalSFS()
{
    if (!globalSfs)   //if globalSfs wasn't initialized before, initialize and connect to it
    {
        console.log("initGlobalSFS: " + globalSFSHost + ":" + globalSFSPort);

       
        // Create configuration object
        var config = {};
        config.host = globalSFSHost;
        config.port = parseInt(globalSFSPort);
        config.zone = ZONE_NAME;
        config.debug = true;
        config.useSSL = (config.port == 8443) ? true : false;   //TODO: lock on true for production

        // Create SmartFox client instance
        globalSfs = new SFS2X.SmartFox(config);
        attachSFSToLogger(globalSfs);
    
        // Add event listeners
        globalSfs.addEventListener(SFS2X.SFSEvent.CONNECTION, onConnection, this);
        globalSfs.addEventListener(SFS2X.SFSEvent.CONNECTION_LOST, onConnectionLost, this);
        globalSfs.addEventListener(SFS2X.SFSEvent.EXTENSION_RESPONSE, onServerMessage, this);
        globalSfs.addEventListener(SFS2X.SFSEvent.PRIVATE_MESSAGE, onPrivateMessage, this);
        globalSfs.connect();
    }

    return globalSfs;
}

export function initSFS(host, port, loginCallback) 
{
    onLoggedIn = loginCallback;

    if (!sfs)   //if sfs wasn't initialized before, initialize and connect to it, then call callback when logged in
    {
        console.log("initSFS: " + host + ":" + port);

        if (globalSfs != null && globalSfs.config.host == host && globalSfs.config.port == port)    //the globalSfs is the same as this casino sfs and we're already connected to global, so nothing else to do here
        {
            sfs = globalSfs;
            console.log("Already connected/connecting to Global SFS, reusing connection for Casino SFS");
            
            sfs.addEventListener(SFS2X.SFSEvent.LOGIN, onLogin, this);
            sfs.addEventListener(SFS2X.SFSEvent.LOGIN_ERROR, onLoginError, this);
            sfs.addEventListener(SFS2X.SFSEvent.LOGOUT, onLogout, this);
            sfs.addEventListener(SFS2X.SFSEvent.ROOM_JOIN, onRoomJoined, this);
            sfs.addEventListener(SFS2X.SFSEvent.ROOM_JOIN_ERROR, onRoomJoinError, this);
            if (globalSfs.isConnected && onLoggedIn)    //otherwise just call the callback immediately
                onLoggedIn();
        }
        else
        {
            // Create configuration object
            var config = {};
            config.host = host;
            config.port = parseInt(port);
            config.zone = ZONE_NAME;
            config.debug = true;
            config.useSSL = (config.port == 8443) ? true : false;   //TODO: lock on true for production

            // Create SmartFox client instance
            sfs = new SFS2X.SmartFox(config);
            attachSFSToLogger(sfs);
        
            // Add event listeners
            sfs.addEventListener(SFS2X.SFSEvent.CONNECTION, onConnection, this);
            sfs.addEventListener(SFS2X.SFSEvent.CONNECTION_LOST, onConnectionLost, this);
            sfs.addEventListener(SFS2X.SFSEvent.EXTENSION_RESPONSE, onServerMessage, this);
            sfs.addEventListener(SFS2X.SFSEvent.LOGIN, onLogin, this);
            sfs.addEventListener(SFS2X.SFSEvent.LOGIN_ERROR, onLoginError, this);
            sfs.addEventListener(SFS2X.SFSEvent.LOGOUT, onLogout, this);
            sfs.addEventListener(SFS2X.SFSEvent.ROOM_JOIN, onRoomJoined, this);
            sfs.addEventListener(SFS2X.SFSEvent.ROOM_JOIN_ERROR, onRoomJoinError, this);
            sfs.connect();
        }
    }
    else if (onLoggedIn)    //otherwise just call the callback immediately
        onLoggedIn();

    return sfs;
}

function onConnection(evtParams)
{
    if (evtParams.success)
    {
        console.log("Connected to SmartFoxServer 2X!");
        var loginData = new SFSObject();
        loginData.putUtfString(TOKEN, get(accessToken));
        loginData.putUtfString(USER_NAME, get(userStore).name);
        loginData.putUtfString(PHOTO, get(userStore).avatar);
        loginData.putUtfString(LOCALE, get(userStore).locale);
        loginData.putDouble(BALANCE,get(userStore).balance);
        if (get(friendsStore))
        {
            if (get(friendsStore).friendIds)
                loginData.putUtfStringArray(FRIENDS, get(friendsStore).friendIds);
            if (get(friendsStore).blockedIds)
                loginData.putUtfStringArray(BLOCKED, get(friendsStore).blockedIds);
        }

        var sfsInstance = sfs ? sfs : globalSfs;
        var isSent = sfsInstance.send(new SFS2X.LoginRequest(get(userStore).user_id, null, loginData));
        if (isSent)
            console.log("Login request sent: " + get(userStore).user_id + " " + loginData.getUtfString("token"));
    }
    else
        console.log("Connection failed. Is the server running at all?");
}

function onConnectionLost(event)
{
	console.log("I was disconnected; reason is: " + event.reason);
}

function onLoginError(event)
{
	console.log("Login error: " + event.errorMessage + " (" + event.errorCode + ")", true);
}

function onLogin(event)
{
	console.log("Login successful!" +
		  "\n\tZone: " + event.zone +
		  "\n\tUser: " + event.user +
		  "\n\tData: " + event.data);

    if (onLoggedIn)
    {
        onLoggedIn();
        onLoggedIn = null;  //call calback only once
    }
}

function onLogout(event)
{
	console.log("Logout from zone " + event.zone + " performed!");
}

function onServerMessage(event)
{
    switch(event.cmd)
    {
        case UPDATE_FRIENDS_MSG:
            updateFriends(event.params);
            break;
        case CALL_AT_TABLE_MSG:
            onCallAtTable(event.params);
            break;
        case UNFRIEND_MSG:
            onUnfriend(event.params);
            break;
    }
}

function onPrivateMessage(e)
{
    let senderName = e.data.getUtfString("senderName");
    showToast(senderName + " says: " + e.message);
}

function updateFriends(params)
{
    console.log("updateFriends");

    let friends = get(friendsStore).friends;
    for(let friend of friends)
        if (params.containsKey(friend.uid))
        {
            let data = params.getSFSObject(friend.uid);
            
            friend.online = data.getBool("online");
            if (friend.online)
            {
                let location = data.getUtfString("location");
                if (location == "map")
                    friend.location = location;
                else
                    friend.location = JSON.parse(location);
            }
        }

    friendsStore.update(friendsData => { 
        friendsData.friends = friends;
        return friendsData;
    });
}

function onCallAtTable(params)
{
    console.log("onCallAtTable");
    let senderId = params.getUtfString("sender");
    let casinoId = params.getUtfString("casinoId");
    let tableId = params.getUtfString("tableId");
    
    let friendName = null;
    let friends = get(friendsStore).friends;
    for(let friend of friends)
        if (friend.uid == senderId)
        {
            friendName = friend.name;
            break;
        }

    let path = "/" + casinoId;
    if (tableId)
        path += "/" + tableId;
    else
        path += "/lobby";
    
    if (confirm(friendName + " invited you to go to their location. Do you accept?"))
        window.location = path;
}

function onUnfriend(params)
    {
        console.log("onUnfriend");
        let senderId = params.getUtfString("senderId");
        let friendId = params.getUtfString("friendId");

        let unfriendId = (senderId == get(userStore).user_id) ? friendId : senderId;

        friendsStore.update(friendsData => { 
            let friends = friendsData.friends;
            for(let i = 0; i<friends.length; i++)
                if(friends[i].uid == unfriendId)
                {
                    friends.splice(i, 1);
                    i--;
                }

            let friendIds = friendsData.friendIds;
            for(let i = 0; i<friendIds.length; i++)
                if(friendIds[i] == unfriendId)
                {
                    friendIds.splice(i, 1);
                    i--;
                }

            friendsData.friends = friends;
            friendsData.friendIds = friendIds;
            return friendsData;
        });

        showToast("You are no longer friends", null);
    }

export function unfriendUser(friendId)
{
    let params = new SFSObject();
    params.putUtfString("friend", friendId);

    if (getGlobalSFS().isConnected)
        getGlobalSFS().send(new SFS2X.ExtensionRequest(UNFRIEND_CMD, params));
    else
        showToast("ERROR: Not connected to SFS", null);
}

export function unblockUser(blockedId)
{
    let params = new SFSObject();
    params.putUtfString("blockedId", blockedId);

    if (getGlobalSFS().isConnected)
        getGlobalSFS().send(new SFS2X.ExtensionRequest(UNBLOCK_CMD, params));
    else
        showToast("ERROR: Not connected to SFS", null);
}

export function callAtTable(friendId)
{
    let params = new SFSObject();
    params.putUtfString("friend", friendId);
    params.putUtfString("casinoId", casinoId);
    if (tableId)
        params.putUtfString("tableId", tableId);
    

    if (getGlobalSFS().isConnected)
        getGlobalSFS().send(new SFS2X.ExtensionRequest(CALL_AT_TABLE_CMD, params));
    else
        showToast("ERROR: Not connected to SFS", null);
}

//---------------------------------------------------------------------------

export function clearLobbyAndTable() 
{
    tableId = null;
    casinoId = null;
    tableRoom = null;
    lobbyRoom = null;
}

export function joinLobby(casino_id, callback) 
{
    casinoId = casino_id;
    tableId = null;
    onJoinedLobby = callback;

    if (sfs && sfs.isConnected)
        sfs.send(new SFS2X.JoinRoomRequest("Casino" + casinoId))   //request to join the lobby room - called after login into the zone or when re-mounting the Lobby component
}

export function joinTable(table_id, casino_id, callback)
{
    tableId = table_id;
    casinoId = casino_id;
    onJoinedTable = callback;

    if (sfs && sfs.isConnected)
        sfs.send(new SFS2X.JoinRoomRequest("Table" + tableId, null, null, true))   //request to join a table room (as spectator) - called when initializing
}

export function leaveTable()
{
    if (sfs && sfs.isConnected)
        sfs.send(new SFS2X.LeaveRoomRequest());  //request to leave the current room
}

function onRoomJoined(evtParams)
{
    console.log("Room joined successfully: " + evtParams.room);

    if (evtParams.room.name == "Casino" + casinoId)
    {
        lobbyRoom = evtParams.room;     //if the room name is casinoId, this must be the lobby room
        tableRoom = null;
        
        if (onJoinedLobby)
            onJoinedLobby();
    }
    else
    {
        tableRoom = evtParams.room;     //otherwise this must be a table room
        lobbyRoom = null;
        
        if (onJoinedTable)
            onJoinedTable();
    }
}

function onRoomJoinError(evtParams)
{
	console.log("Room joining failed: " + evtParams.errorMessage);
}

export function updateLocation(locationObj)
{
    console.log("updateLocation");
    if (!locationObj)
        locationObj = "map";

    let params = new SFSObject();
    params.putUtfString("location", JSON.stringify(locationObj));

    if (getGlobalSFS().isConnected)
        getGlobalSFS().send(new SFS2X.ExtensionRequest(UPDATE_USER_LOCATION_CMD, params));
    else
        showToast("ERROR: Not connected to SFS", null);
}

//---------------------------------------------------------------------------

export function getSFS()
{
    return sfs;
}

export function getGlobalSFS()
{
    return globalSfs;
}


export function getTableRoom()
{
    return tableRoom;
}

export function getLobbyRoom()
{
    return lobbyRoom;
}